export enum AdminInsightsExportEvent {
    Success = 'AdminInsightsExport.Success',
    Failed = 'AdminInsightsExport.Failed',
    Cancel = 'AdminInsightsExport.Cancel',
    Click = 'AdminInsightsExport.Click',
}
